import {inject, Injectable} from '@angular/core';
import {BaseApiService} from "./base-api.service";
import {TableSort} from "../interfaces/table/table-sort";

@Injectable({
  providedIn: 'root'
})
export class JobsService {
  private readonly apiService = inject(BaseApiService);

  async getJobs(limit: number, offset: number, search: string, order: TableSort | null, jobTypeId: string | null, statusId: string, statusCategoryId: string, locationId: string) {
    const body = {
      offset: offset,
      limit: limit,
      search: search,
      sort: JSON.stringify(order),
      showInactive: false,
      jobTypeId: jobTypeId == '0' || !jobTypeId ? null : jobTypeId,
      statusId: statusId == '0' || !statusId ? null : statusId,
      statusCategoryId: statusCategoryId,
      locationId: locationId == '0' || !locationId ? null : locationId
    };
    return await this.apiService.post('/jobs', body);
  }

  async getJobTypes() {
    return await this.apiService.get(`/jobs/job-types`);
  }

  async getJobStatuses() {
    return await this.apiService.get(`/jobs/job-statuses`);
  }

  async getLocations() {
    return await this.apiService.get(`/locations`);
  }

  async getJobById(id: string) {
    return this.apiService.get(`/jobs/${id}`);
  }

  async getJobAssetsById(id: string) {
    return this.apiService.get(`/jobs/${id}/assets`);
  }

  async getJobHistory(id: string) {
    return await this.apiService.get(`/jobs/${id}/history`);
  }

  async getJobComment(id: string) {
    return await this.apiService.get(`/jobs/${id}/comments`);
  }

  async createJobComment(id: string, commentContent: string) {
    const body = {
      comment_content: commentContent
    }
    return await this.apiService.post(`/jobs/${id}/comments`, body);
  }

  updateJobComment(id: string, commentId: string, commentContent: string) {
    const body = {
      job_comment_id: commentId,
      comment_content: commentContent
    }
    return this.apiService.put(`/jobs/${id}/comments`, body);
  }

  deleteJobComment(id: string, commentId: string) {
    const body = {
      job_comment_id: commentId
    }
    return this.apiService.post(`/jobs/${id}/comments/delete`, body);
  }

  async getJobAttachments(id: string) {
    return await this.apiService.get(`/jobs/${id}/attachments`);
  }

  async getJobAttachmentsWithPagination(id: string, attachmentTypeId: string, search: string, limit: number, offset: number) {
    const body = {
      jobId: id,
      attachment_type_id: attachmentTypeId,
      search: search,
      limit: limit,
      offset: offset
    };
    return await this.apiService.post(`/jobs/attachments`, body);
  }

  async getJobCustomFields(id: string) {
    return await this.apiService.get(`/jobs/${id}/job-custom-fields`);
  }

  async getJobsExportData(jobTypeId: string | null, search: string | null, statusId: string | null, locationId: string | null, fileType: string) {
    const body = {
      Search: search,
      JobTypeId: jobTypeId == '0' || !jobTypeId ? null : jobTypeId,
      StatusId: statusId == '0' || !statusId ? null : statusId,
      LocationId: locationId == '0' || !locationId ? null : locationId,
      FileType: fileType,
    };

    return this.apiService.post('/jobs/export', body);
  }

  async getJobsRentalExportData(jobTypeId: string | null, search: string | null, statusId: string | null, locationId: string | null, fileType: string) {
    const body = {
      Search: search,
      JobTypeId: jobTypeId == '0' || !jobTypeId ? null : jobTypeId,
      StatusId: statusId == '0' || !statusId ? null : statusId,
      LocationId: locationId == '0' || !locationId ? null : locationId,
      FileType: fileType
    };

    return this.apiService.post('/jobs/rental-export', body);
  }
}
